import { useState } from "react";
import { usePreview } from "utils/sms";
import t from "utils/translate";
import nameFieldData from "../../../../../../Profile/AccountCreate/fieldData";
import Textfield from "../../../../../../Profile/Textfield";
import useAppContext from "components/AppContext";
import coupon from "./imgs/coupon.svg";
import {
  COUPON_REDEEMABLE,
  TERMS_AND_CONDITIONS
} from "components/ClinicCheckout/constants";
import { getTemplateContentMap } from "utils/useBundle";
import { logger } from "utils/logger";
import { formatPrice } from "utils/formatPrice";

import styles from "./styles.module.scss";

const CouponCode = ({ onChange, setDiscount, plan }) => {
  const [show, setShow] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const { contact } = useAppContext();
  const { market } = contact;
  const { currency = "USD" } = plan;

  const { trigger: preview, isMutating: previewIsMutating } = usePreview();

  const applyCouponCode = async e => {
    e.preventDefault();

    try {
      const res = await preview({
        market,
        payload: {
          offerPlanIds: [plan.id],
          couponCodes: [code]
        }
      });

      const { discount, total, coupons } = (res.data?.result ?? [])[0] || {};
      const coupon = coupons?.[0];
      const templateContentMap = getTemplateContentMap({
        data: coupon?.templateContents,
        filterFunc: content => content?.templateContent?.locale === market
      });
      if (coupon) {
        if (coupon.state === COUPON_REDEEMABLE) {
          const formattedTotal = formatPrice(total, market, currency);
          const formattedDiscount = formatPrice(discount, market, currency);
          setDiscount({
            discount: `-${formattedDiscount}`,
            total: formattedTotal,
            terms: templateContentMap?.get(TERMS_AND_CONDITIONS)
          });
          onChange("couponCode", code);
          setError("");
        } else {
          setError(t("COUPON_CODE_INVALID"));
        }
      } else {
        setError(t("COUPON_CODE_ERROR"));
      }
    } catch (error) {
      logger("Error previewing coupon code", {
        level: "error",
        customAttributes: { error }
      });
      setError(t("COUPON_CODE_ERROR"));
    }
  };

  const changeCouponCode = (e, value) => {
    setCode(value);

    if (error) {
      setError("");
    }
  };

  return (
    <div className={styles.couponCode}>
      {!show && (
        <button
          className={styles.showCouponCode}
          da-category="quiz"
          da-label="quiz:add_coupon_code"
          da-action="add_coupon_code"
          onClick={e => {
            e.preventDefault();
            setShow(!show);
          }}
        >
          <img width="20" height="20" alt="" src={coupon} />
          {t("COUPON_CODE_ADD")}
        </button>
      )}
      {show && !previewIsMutating && (
        <>
          <div className={styles.couponCodeField}>
            <Textfield
              {...nameFieldData.couponCode}
              name="couponCode"
              styles={styles}
              wrapperClassName={styles.couponCodeWrapper}
              inputWrapperClassName={styles.couponCodeInputWrapper}
              value={code}
              onChange={changeCouponCode}
              withAutofocus={false}
              inputPreset="billing"
            />
            <button
              type="button"
              className={styles.showCouponCode}
              da-category="quiz"
              da-label="quiz:apply_coupon_code"
              da-action="apply_coupon_code"
              onClick={applyCouponCode}
            >
              {t("COUPON_CODE_APPLY")}
            </button>
          </div>
          <div className={styles.error}>{error}</div>
        </>
      )}
      {previewIsMutating && <div className={styles.loading}></div>}
    </div>
  );
};

export default CouponCode;
